//import Libraries
import React from 'react';
import {connect} from 'react-redux';

//import Components
import DetailProduct from './DetailProduct';

import Language from '../../../language/language';

import * as cartActions from '../actions/cartActions';

//import Style classes
import './DetailProductList.css';

const detailProductList = (props) => {

    let {products} = props;

    if(products.length === 0) {
        return (
            <div className="NoProduct">
                {Language.store.noProduct[props.universal.language]}
            </div>
        );
    }

    return(
        <div>
            {
                products.map((product, index)  => {
                    return (
                        <DetailProduct 
                            universal={props.universal}
                            product={product}
                            onAddToCart={props.onAddToCart} 
                            key={index}
                        />
                    );
                })
            }
        </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddToCart : (data) => {
            dispatch(cartActions.addToCart(data))
        }
    }
}
 
export default connect(null, mapDispatchToProps)(detailProductList);


// WEBPACK FOOTER //
// ./src/pages/Store/DetailProduct/DetailProductList.js